import { useRouter } from 'next/router'
import Icon from '@/components/Icons'
import { Wrapper, Graphic, Content, ImageWrapper, Text, AusImage } from './Campaign.styles'
import { Button, Heading } from '@big-red-group/storefront-common-ui'
import { CampaignProps } from '@/types'

const Campaign: React.FC<CampaignProps> = ({ title, buttonLabel, url, image, fullWidth = false }) => {
  const router = useRouter()
  const AUS_MASK_IMAGE_URL =
    'https://cdn.experienceoz.com.au/assets/imgproxy/catalogueType/2/miscGraph/150067.png?format=webp'

  return (
    <Wrapper fullWidth={fullWidth}>
      <Graphic>
        <Icon name="backgroundStroke" color="#f7b225" />
      </Graphic>
      <Content fullWidth={fullWidth}>
        <Text fullWidth={fullWidth}>
          <Heading size="XXL" balanced>
            {title}
          </Heading>
          <Button size="L" alternate onClick={() => router.push(url)}>
            {buttonLabel}
          </Button>
        </Text>
        <ImageWrapper>
          <AusImage imageUrl={image} maskImageUrl={AUS_MASK_IMAGE_URL} />
        </ImageWrapper>
      </Content>
    </Wrapper>
  )
}

export default Campaign
